<template>
  <div calss="system">
    <div class="banner" v-if="isMobile" :data="datalist" :style="{ backgroundImage: `url(${datalist.mbanner})` }">
      <!-- <img :src="datalist.banner" alt=""> -->
        <h1 class="bannerTitle">{{ datalist.name }}</h1>
        <p>{{datalist.description}}</p>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
            <button @click="goToContact(3)" class="inner-ri">Contact us</button>
        </div>
    </div>
    <div class="banner" v-else :data="datalist" :style="{ backgroundImage: `url(${datalist.banner})` }">
      <!-- <img :src="datalist.banner" alt=""> -->
        <div class="bannerTitle2">{{ datalist.name }}</div>
        <p class="bannerText">{{datalist.description}}</p>
        <div class="inner_btn">
            <button @click="goToContact(2)" class="inner-le">Eco-cooperation</button>
            <button @click="goToContact(3)" class="inner-ri">Contact us</button>
        </div>
    </div>
    <div class="sys-main" v-for="item in datalist.items" :key="item.id">
          <div class="sys-title">
            <h1 v-if="item.itemType===1">{{item.itemContent}}</h1>
            <h3 v-if="item.itemType===6">{{ item.itemContent }}</h3>
            <ul v-else-if="item.itemType===7" class="dot-list">
              <li v-for="(listItem, index) in parseListContent(item.itemContent)" :key="index">
                {{ listItem }}
              </li>
            </ul>
             <!-- 功能特点 -->
          <div class="detail_main"  v-else-if="item.itemType===8">
            <div class="sys-detail">
              <div class="sys-card" v-if="isMobile">
                <el-row :gutter="20">
                  <el-col :span="24" v-for="(feature, index) in parseCoreFeatures(item.itemContent)" :key="index">
                    <div class="grid-content ep-bg-purple">
                      <h3>{{ feature.title }}</h3>
                      <ul>
                        <li v-for="(item2, itemIndex) in feature.valueList" :key="itemIndex">
                          <p>{{ item2 }}</p>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <div class="sys-card" v-else>
                <el-row :gutter="20">
                  <el-col :span="6" v-for="(feature, index) in parseCoreFeatures(item.itemContent)" :key="index">
                    <div class="grid-content ep-bg-purple">
                      <h3 class="type8title">{{ feature.title }}</h3>
                      <ul>
                        <li v-for="(item, itemIndex) in feature.valueList" :key="itemIndex">
                          <p>{{ item }}</p>
                        </li>
                      </ul>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          </div>
          <div v-if="item.itemType===3" class="show-video">
            <video :src="item.itemContent" controls></video>
          </div>
          <div v-if="item.itemType===4" class="show-img" :style="{ background: `url(${item.itemContent}) no-repeat center` }">
          </div>
          <div class="show-p">
            <p v-if="item.itemType===2">{{ item.itemContent }}</p>
          </div>
    </div>
    <!-- success -->
     <div v-if="(case_data||[]).length" class="success_outer">
      <div class="success">
      <h1>Success cases</h1>
      <div class="succ-box" v-if="isMobile">
        <el-row :gutter="20">
          <el-col :span="24" v-for="item in case_data" :key="item.id" style="height: 18em;">
            <div class="grid-content ep-bg-purple">
              <div class="grid-top">
                <img :src="item.thumbnail" alt="">
              </div>
              <div class="grid-bottom" @click="goto_case(item.id)">
                <h3>{{ item.name }}</h3>
                <p>{{ item.description }}</p>
                <el-button>MORE</el-button>
              </div>
              </div>
            </el-col>
            </el-row>
      </div>
      <div class="succ-box" v-else>
        <el-row :gutter="20">
          <el-col :span="8" v-for="item in case_data" :key="item.id" style="height: 25em;">
            <div class="grid-content ep-bg-purple">
              <div class="grid-top">
                <img :src="item.thumbnail" alt="">
              </div>
              <div class="grid-bottom">
                <div class="type9title">{{ item.name }}</div>
                <p>{{ item.description }}</p>
                <el-button @click="goto_case(item.id)">MORE</el-button>
              </div>
              </div>
            </el-col>
            </el-row>
      </div>
      
    </div>
    </div>
  </div>
</template>

<script setup name="System_platformEN">
import { onMounted,ref ,onUnmounted} from 'vue';
import { useRoute,useRouter } from 'vue-router';
import { getProductDetail } from '@/api/product';
const route = useRoute()
const router = useRouter()
const case_data = ref([]);
const id = route.query.id; 
console.log(id);
onMounted(() => {
  window.scrollTo(0, 0);
  checkmobile()
  window.addEventListener('resize', checkmobile)
  case_data.value = [];
  prorender()
})
onUnmounted(() => {
  window.removeEventListener('resize', checkmobile)
})
import { watch } from 'vue'
//监听页面变化
const isMobile=ref(false)
const checkmobile=() => {
    isMobile.value = window.innerWidth <= 1024; 
}
// 监听id参数变化
watch(
  () => route.query.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      case_data.value = []; // 清空case_data数组
      prorender() // 重新获取数据
    }
  },
  { immediate: true } // 立即执行一次
)
const datalist = ref([])
async function prorender() {
  const id = route.query.id; 
  const res = await getProductDetail(id)
  datalist.value = res.data
  case_data.value = res.data.subObjects;
}
const emit = defineEmits(['scroll-to-contact'])
function goToContact(type) {
  emit('scroll-to-contact', type)
}
function goto_case(id){
  router.push(`/en/system?id=${id}`)
}
const parseListContent = (content) => {
  if (!content) return [];
  return content
    .split('\n')
    .map(item => item.trim())
    .filter(item => item.length > 0)
    .map(item => item.replace(/^[•·\-\*]\s*/, '')); // 移除开头的符号
};
const parseCoreFeatures = (itemContent) => {
  try {
    const parsed = Array.isArray(itemContent) ? itemContent : JSON.parse(itemContent);
    return parsed.map(feature => ({
      title: feature.title,
      valueList: feature.valueList ? feature.valueList.split(';').filter(s => s && s.trim()) : []
    }));
  } catch (e) {
    console.error('解析核心功能数据失败:', e);
    return [];
  }
};
const getCoreFeatures = () => {
  if (!datalist.value.items) return [];
  
  const coreFeatureItems = datalist.value.items.filter(item => item.itemType === 8);
  const features = [];
  
  coreFeatureItems.forEach(item => {
    try {
      // 如果 itemContent 已经是数组，直接使用
      const parsedFeatures = Array.isArray(item.itemContent) ? item.itemContent : JSON.parse(item.itemContent);
      parsedFeatures.forEach(feature => {
        features.push({
          title: feature.title,
          valueList: feature.valueList ? feature.valueList.split(';').filter(item => item.trim()) : []
        });
      });
    } catch (e) {
      console.error('解析核心功能数据失败:', e);
    }
  });
  
  return features;
};
</script>

<style scoped>
.banner{
  overflow: hidden;
  width: 100%;
  height: 12em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color:white;
  background-color: #ddd;
  margin-bottom: 0em;
  background-size: 100% 100%;
  background-position: center;
  text-align: left;
  background-repeat: no-repeat;
}
.inner-le,.inner-ri{
  width: 10em;
  height: 2.2em;
  border-radius: 1.5em;
  font-size: 1em;
  border:transparent;
  cursor: pointer;
  margin: 1em auto;
}
.inner_btn{
  margin-left: 18%;
}
.inner-le{
  background-color: orange;
  color: white;
  margin-right: 1em;
}
.inner-ri{
  background-color: skyblue;
  color: white;
}
.banner h1,.banner p{
  width: 65%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 1em;
  margin-left: 18%;
}
.sys-main{
  width: 60%;
  margin: 0 auto;
}

.sys-main .sys-title>p,.sys-detail .sys-title>p{
  margin-top: 2em;
  margin-bottom: 2em;
}
.sys-title>h1{
  height: 4em;
  display: flex;
  align-items: center;
}
.sys-main .show-video video,.sys-main .show-video img{
  width: 100%;
  height: 30em;
}
.sys-main .show-img{
  width: 100%;
  height: 30em;
  background-size: contain !important; /* 改为cover确保填满容器 */
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
.sys-main .show-p>p{
  text-indent: 2em;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
  line-height: 2em;
}
.sys-detail{
  width: 100%;
  margin: 0em auto;
}
.sys-detail .sys-card .grid-content{
  overflow: hidden;
  width: 100%;
  margin-bottom: 1em;
  margin-top: 1em;
  box-shadow: 1px 1px 10px -4px #ddd;
}
.sys-detail .sys-card .grid-content>h3{
  color:white;
  height: 2.5em;
  width: 100%;
  text-align: center;
  margin: 0em auto;
  background-color: #6E6BF3 ;
  line-height: 2.5em;
}
.sys-detail .sys-card .grid-content>ul{
  width: 90%;
    background-color: #fff;
    height: auto; /* 改为自适应高度 */
    /* min-height: 6em; 设置最小高度 */
    margin: 0 auto;
    padding: 1em 0; /* 添加上下内边距 */
}
.sys-detail .sys-card .grid-content>ul li {
    width: 90%;
    margin: 1em auto; /* 减小上下间距 */
}
.sys-detail .sys-card .grid-content > ul li p {
    height: auto; /* 改为自适应高度 */
    line-height: 1.5em; /* 减小行高 */
    font-size: 0.8em;
    margin: 0.5em 0; /* 添加段落间距 */
}

.sys-detail .sys-card .grid-content > ul li::marker {
  color: #409EFF;
}
.success_outer{
  width: 100%;
  overflow: hidden;
  background-color: #F9FAFC ;
}
.success{
  width: 60%;
  margin: 4em auto;
}
.success>h1{
  margin-bottom: 1em;
}
.sol-h{
  display: flex;
  align-items: center;
  width: 100%;
  height: 3em;
}
.sol-h .box{
  display: inline-block;
  width: 0.5em;
  height: 2em;
  background-color: #0073FF;
}
.sol-h h1{
  display: inline-block;
  /* height: 3em;
  line-height: 3em; */
  margin-left: 0.5em;
}
.sol-p{
  width: 100%;
  text-indent: 2em;
  margin-bottom: 4em;
}
.success .succ-box{
  margin-top: 4em;
}
.success .succ-box .grid-content{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.success .succ-box .grid-content .grid-top{
  width: 100%;
  height: 40%;
}
.success .succ-box .grid-content .grid-top img{
  width: 100%;
  height: 100%;
}
.success .succ-box .grid-content .grid-bottom{
  width: 90%;
  height: 60%;
  margin: 0 1em;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.success .succ-box .grid-content .grid-bottom>p{
  display: -webkit-box;
  height: 3em;
  -webkit-line-clamp: 2; /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.success .succ-box .grid-content .grid-bottom h3,.success .succ-box .grid-content .grid-bottom p{
  margin: 1em 0;
}
.success .succ-box .grid-content .grid-bottom h3{
  height: 2em;
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
}
.success .succ-box .grid-content .grid-bottom .el-button{
  width: 30%;
  margin: 1.5em 0;
  border:1px solid #000;
  border-radius: 0;
  color: #000;
}
.dot-list {
  font-weight: bold;
  margin: 1em 0;
  padding-left: 1.2em;
}
.dot-list li {
  list-style: disc;
  font-size: 18px;
  margin: 0.5em 0;
  line-height: 1.6;
}
@media (max-width:1024px){
  .banner{
    height: 12em;
    margin-bottom: 1em;
    text-align: center;
  }
  .banner h1{
  font-size: 1.2em;
  margin-top: 1em;
  margin-left: 3em;
  text-align: left; 
  width: 80%;
  }
  .banner p{
    margin-top: 1.2em;
    margin-left: 3em;
    text-align: left; 
    width: 80%;
  }
  .inner_btn{
  margin-left: 0;
  }
  .inner-le,.inner-ri{
  font-size: 0.8em;
  height: 2.5em;
}
.sys-main{
  width: 88%;
  margin: 0 auto;
}

.sys-main .sys-title>p,.sys-detail .sys-title>p{
  font-size: 0.8em;
}
.sys-main .show-video video,.sys-main .show-video img{
  height: 15em;
}
.sys-main .show-p>p{
  text-indent: 2em;
  width: 100%;
  margin-top: 1em;
  margin-bottom: 1em;
  line-height: 2em;
  font-size: 0.8em;
}
.detail_main{
  width: 100%;
  background-color: #F9FAFC;
  padding: 1em 0;
}
.sys-detail{
  /* text-align: center; */
  width: 88%;
  margin: 1em auto;
  
}
.sys-detail .sys-title>h1{
  font-size: 1.2em;
}
.sys-detail .sys-title>p{
  margin-top: 0.5em;
}
.sys-detail .sys-card .grid-content{
  overflow: hidden;
  width: 100%;
}
.sys-detail .sys-card .grid-content>h3{
  color:white;
  height: 2em;
  width: 100%;
  text-align: center;
  margin: 0em auto;
  background-color: #6E6BF3 ;
  line-height: 2em;
  font-size: 0.9em;
}
.sys-detail .sys-card .grid-content>ul{
  width: 90%;
  background-color: #fff;
  margin: 0 auto;
  display: block;
  padding: 0 10px;
}
.sys-detail .sys-card .grid-content>ul li{
  width: 90%;
  margin: .2em auto;
  /* display: inline-block; */
}
.sys-detail .sys-card .grid-content>ul li p{
  /* height: 2em; */
  /* line-height: 2em; */
  font-size: 0.8em;
}
.sys-detail .sys-card .grid-content > ul li::marker {
  color: #409EFF;
}
.success_outer{
  width: 100%;
  overflow: hidden;
  background-color: #005BAC ;
}
.success{
  text-align: center;
  width: 90%;
  margin: 1em auto;
}
.success>h1{
  font-size: 1.2em;
  margin-bottom: 1em;
}
.success>p{
  font-size: 0.8em;
}

.success .succ-box{
  margin-top: 1em;
  margin-bottom: 1em;
}
.success .succ-box .el-col{
  margin-bottom: 1em;
}
.success .succ-box .grid-content{
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.success .succ-box .grid-content .grid-top{
  width: 100%;
  height: 40%;
}
.success .succ-box .grid-content .grid-top img{
  width: 100%;
  height: 100%;
}
.success .succ-box .grid-content .grid-bottom{
  width: 90%;
  height: 60%;
  margin: 0 1em;
  display: flex;
  flex-direction: column;
  text-align: left;
}
.success .succ-box .grid-content .grid-bottom>p{
  display: -webkit-box;
  font-size: 0.8em;
  -webkit-line-clamp: 2; /* 限制显示3行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.5em;
}
.success .succ-box .grid-content .grid-bottom h3,.success .succ-box .grid-content .grid-bottom p{
  margin: 0;
}
.success .succ-box .grid-content .grid-bottom h3{
  font-size: 1em;
  display: flex; 
  flex-wrap: wrap;
  align-items: flex-end;
  margin-top: 1em;
  margin-bottom: 1em;
}
.success .succ-box .grid-content .grid-bottom .el-button{
  width: 20%;
  margin: 1em 0;
  font-size: 0.8em !important;
  border-radius: 0;
  color: #000;
}

.sys-main .show-img{
  width: 100%;
  height: 16em;
  background-size: contain !important; /* 改为cover确保填满容器 */
  background-position: center center !important;
  background-repeat: no-repeat !important;
}
}
.sys-detail .sys-card .grid-content {
  overflow: hidden;
  width: 100%;
  margin-bottom: 1em;
  margin-top: 1em;
  box-shadow: 1px 1px 10px -4px #ddd;
  display: flex;
  flex-direction: column;
  height: 100%; /* 确保高度占满父容器 */
}

/* 修改 el-row 样式以支持等高 */
.sys-detail .sys-card .el-row {
  display: flex;
  flex-wrap: wrap;
}

.sys-detail .sys-card .el-col {
  display: flex;
  flex-direction: column;
}

/* 确保 ul 元素能够扩展填充剩余空间 */
.sys-detail .sys-card .grid-content > ul {
  width: 90%;
  font-size: 0.9em;
  background-color: #fff;
  flex-grow: 1; /* 让 ul 占满剩余空间 */
  margin: 0 5%;
}

/* 为成功案例部分添加等高布局 */
.success .succ-box .el-row {
  display: flex;
  flex-wrap: wrap;
}

.success .succ-box .el-col {
  display: flex;
  flex-direction: column;
}

.success .succ-box .grid-content {
  width: 100%;
  height: 100%; /* 确保高度占满父容器 */
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.bannerTitle2 {
  font-size: 22px;
  font-weight: 600;
  -webkit-line-clamp: 1; /* 限制显示2行 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 65%;
  margin-left: 18%;
}

.bannerText {
  display: -webkit-box;
  -webkit-line-clamp: 2; /* 限制显示2行 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5em; /* 设置合适的行高 */
  max-height: 3em; /* 2行的高度，基于1.5em行高 */
  margin: 0.5em 0;
}
.type8title {
  overflow: hidden;
  text-overflow: ellipsis;
}
/* 添加 type8title 样式 */
.sys-detail .sys-card .grid-content .type8title,
.sys-detail .sys-card .grid-content > h3 {
  color: white;
  height: 2.5em;
  width: 100%;
  text-align: center;
  margin: 0 auto;
  background-color: #6E6BF3;
  line-height: 2.5em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0 0.5em;
  box-sizing: border-box;
  word-break:break-all
}

/* 移动端适配 */
@media (max-width:1024px) {
  .sys-detail .sys-card .grid-content .type8title,
  .sys-detail .sys-card .grid-content > h3 {
    height: 2em;
    line-height: 2em;
    font-size: 0.9em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .type9title {
    font-size: 1.2em;
    height: 2.6em;
    line-height: 1.3em;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.type9title {
  font-size: 1.4em;
  font-weight: bold;
  height: 3em;
  line-height: 1.5em;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 0.2em;
  margin-bottom: 0.2em;
  word-break: break-all;
}

</style>